import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { isEnabled } from "utils/featureFlags";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import EmptyOptimize from "components/UnifiedProject/Optimize/EmptyOptimize";
import DoubleOptimize from "components/UnifiedProject/Optimize/Double/DoubleOptimize";
import Balance from "components/UnifiedProject/Optimize/Double/Balance";

import * as projectReducer from "containers/Project/reducer";
import * as viewReducer from "containers/View/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as deployReducer from "containers/Deployments/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";

export const getRunId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.runId
      ? props.match.params.runId
      : 2860;

class OptimizeContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  getIsActiveOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.activeSegment &&
      optimized.activeSegment.conditions.length === 0 &&
      optimized.activeSegment.job &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  render() {
    const {
      match,
      setup,
      isBalance,
      aibleViewType,
      isTableauMode,
      project,
      optimized,
      optimizer,
      segmentOptions,
      modelGroups,
      updateDrilldownValue
    } = this.props;

    return setup !== undefined && Object.keys(setup).length > 0 ? (
      true ? (
        isEnabled("balancer") && isBalance ? (
          <Balance {...this.props} />
        ) : (
          <DoubleOptimize {...this.props} />
        )
      ) : (
        <EmptyOptimize {...this.props} />
      )
    ) : (
      <LoadingIndicator />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getRunId(ownProps);

  return {
    init: (aibleViewType) => dispatch(projectReducer.init(id, aibleViewType)),
    updateDrilldownValue: (runId, value) => dispatch(projectReducer.updateDrilldownValue(id, runId, value)),
    setMinBudget: (runId, budget) => dispatch(projectReducer.setSegmentMinBudgetByRunId(id, runId, budget)),
    setMaxBudget: (runId, budget) => dispatch(projectReducer.setSegmentMaxBudgetByRunId(id, runId, budget)),

    updateTruePositive: (runId, val) => {
      dispatch(setupReducer.updateTruePositive(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateFalsePositive: (runId, val) => {
      dispatch(setupReducer.updateFalsePositive(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateTrueNegative: (runId, val) => {
      dispatch(setupReducer.updateTrueNegative(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateFalseNegative: (runId, val) => {
      dispatch(setupReducer.updateFalseNegative(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionGain: (runId, val) => {
      dispatch(setupReducer.updateConversionGain(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionCost: (runId, val) => {
      dispatch(setupReducer.updateConversionCost(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionMissed: (runId, val) => {
      dispatch(setupReducer.updateConversionMissed(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },
    updateConversionSaved: (runId, val) => {
      dispatch(setupReducer.updateConversionSaved(runId, val, true));
      dispatch(projectReducer.resetBudget(id));
    },

    updateBaselineConversionGain: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionGain(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },
    updateBaselineConversionCost: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionCost(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },
    updateBaselineConversionMissed: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionMissed(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },
    updateBaselineConversionSaved: (runId, val) => {
      dispatch(setupReducer.updateBaselineConversionSaved(runId, val));
      dispatch(projectReducer.resetBudget(id));
    },

    updateExpectedCountContinuous: (runId, val) => dispatch(setupReducer.updateExpectedCountContinuous(runId, val)),
    updateExpectedValueContinuous: (runId, val) => dispatch(setupReducer.updateExpectedValueContinuous(runId, val)),

    updateCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    },

    updateBaselineCustomValue: (runId, blueprintId, valId, value) => {
      dispatch(setupReducer.updateBaselineCustomValue(runId, blueprintId, valId, value));
      dispatch(projectReducer.resetBudget(id));
    },

    updateOutcomePercentage: (runId, percentage) => {
      dispatch(projectReducer.updateOutcomePercentage(id, runId, percentage));
    },

    updateIsRealityHammer: (runId, isRealityHammer) => {
      dispatch(setupReducer.updateIsRealityHammer(runId, isRealityHammer));
      dispatch(projectReducer.resetBudget(id));
    },

    addUserRoleToSegment: (segmentId, userId, role) =>
      dispatch(projectReducer.addUserRoleToSegment(id, segmentId, userId, role)),
    deleteUserRoleFromSegment: (segmentRoleId) => dispatch(projectReducer.deleteUserRoleFromSegment(id, segmentRoleId)),
    deleteUserFromProject: (userId) => dispatch(projectReducer.deleteUserFromProject(id, userId)),
    patchUserRoleSegment: (segmentRoleId, role) =>
      dispatch(projectReducer.patchUserRoleSegment(id, segmentRoleId, role)),
    approveAssumption: (assumptionId) => dispatch(projectReducer.approveAssumption(id, assumptionId)),
    restoreAssumption: (assumptionId) => dispatch(projectReducer.restoreAssumption(id, assumptionId)),
    deleteAssumption: (assumptionId) => dispatch(projectReducer.deleteAssumption(id, assumptionId)),
    viewAssumption: (assumption) => dispatch(projectReducer.viewAssumption(id, assumption)),

    createSplits: (splitOne, splitTwo) => dispatch(projectReducer.createSplits(id, splitOne, splitTwo)),

    rerunSegment: (segmentId) => dispatch(projectReducer.rerunSegment(id, segmentId)),

    updateIsBusinessMode: (isBusiness) => dispatch(globalReducer.updateIsBusinessMode(isBusiness)),

    updateAibleViewType: (view) => dispatch(projectReducer.setAibleViewType(id, view)),

    updateIsBusinessReality: (runId, value) => dispatch(runReducer.updateIsBusinessReality(runId, value)),

    updateCompareScenarioIndex: (index) => dispatch(projectReducer.updateCompareScenarioIndex(id, index)),

    viewScenario: (scenario, index) => dispatch(projectReducer.viewScenario(id, scenario, index)),
    deleteScenario: () => dispatch(projectReducer.deleteScenario(id)),
    saveScenario: (name) => dispatch(projectReducer.saveScenario(id, name)),
    shortlistScenario: () => dispatch(projectReducer.shortlistScenario(id)),
    removeShortlist: () => dispatch(projectReducer.removeShortlist(id)),

    resetBudget: () => dispatch(projectReducer.resetBudget(id)),

    updateScaledTotal: (runId, s) => dispatch(setupReducer.updateScaledTotal(id, runId, s)),

    updateInnerId: (innerId) => dispatch(projectReducer.updateInnerId(id, innerId)),

    deploy: () => dispatch(projectReducer.deploy(id)),

    refresh: () => dispatch(projectReducer.refresh(id)),

    updateModelFeedback: (runId, modelId, isLiked) =>
      dispatch(projectReducer.updateModelFeedback(runId, modelId, isLiked)),

    updateTerminalConditions: (terminalConditions) =>
      dispatch(projectReducer.updateTerminalConditions(id, terminalConditions)),
    updateActivityConditions: (activityConditions) =>
      dispatch(projectReducer.updateActivityConditions(id, activityConditions)),
    updateUniqueId: (uniqueId) => dispatch(projectReducer.updateUniqueIdName(id, uniqueId)),
    updateBusinessPredictionName: (businessPredictionName) =>
      dispatch(projectReducer.updateBusinessPredictionName(id, businessPredictionName)),
    updateFrontierPercentProcessedMin: (runId, frontierPercentProcessedMin) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMin(runId, frontierPercentProcessedMin)),
    updateFrontierPercentProcessedMax: (runId, frontierPercentProcessedMax) =>
      dispatch(setupReducer.updateFrontierPercentProcessedMax(runId, frontierPercentProcessedMax)),
    setFrontierPercentProcessed: (value, useDefault) =>
      dispatch(setupReducer.setFrontierPercentProcessed(id, value, useDefault)),
    updateShowShortListed: (val) => dispatch(projectReducer.updateShowShortListed(id, val)),
    updateShowPending: (val) => dispatch(projectReducer.updateShowPending(id, val)),

    updateProjectMode: (val) => dispatch(projectReducer.updateProjectMode(id, val)),

    updateProjectSetting: (key, val) => dispatch(projectReducer.updateProjectSetting(id, key, val)),

    updateSliderView: (val) => dispatch(projectReducer.updateSliderView(id, val)),

    updateCurrentProjectId: (newId) => dispatch(globalReducer.updateCurrentProjectId(newId)),

    updateMonitorViewMode: (mode) => dispatch(monitoringReducer.updateMonitorViewMode(id, mode)),

    fetchMonitorData: () => dispatch(projectReducer.fetchMonitorData(id)),

    retrainProjectFromDataset: (datasetId) => dispatch(projectReducer.retrainProjectFromDataset(id, datasetId)),

    resetDatasetOutcome: () => dispatch(projectReducer.resetDatasetOutcome(id)),

    goToDeploy: () =>
      dispatch(
        unifiedProjectReducer.updateCurrentStep(ownProps.id, unifiedProjectReducer.UNIFIED_PROJECT_STEPS.DEPLOY.id)
      ),

    goToBalance: () =>
      dispatch(
        unifiedProjectReducer.updateCurrentStep(ownProps.id, unifiedProjectReducer.UNIFIED_PROJECT_STEPS.BALANCE.id)
      ),

    goToOptimize: () =>
      dispatch(
        unifiedProjectReducer.updateCurrentStep(ownProps.id, unifiedProjectReducer.UNIFIED_PROJECT_STEPS.OPTIMIZE.id)
      ),

    toggleCustomMapping: (runId, blueprintId, customFieldId) =>
      dispatch(setupReducer.toggleCustomMapping(runId, blueprintId, customFieldId)),

    updateAdvancedRevenueLabel: (runId, label) => dispatch(setupReducer.updateAdvancedRevenueLabel(runId, label)),
    updateAdvancedCostLabel: (runId, label) => dispatch(setupReducer.updateAdvancedCostLabel(runId, label)),
    updateNetImpactLabel: (runId, label) => dispatch(setupReducer.updateNetImpactLabel(runId, label)),
    updateLinkedRunId: (runId, linkedRunId) => dispatch(setupReducer.updateLinkedRunId(runId, linkedRunId)),

    updateLinkedProjectId: (linkedProjectId) => dispatch(projectReducer.updateLinkedProjectId(id, linkedProjectId)),
    updateHasLinkedProject: (hasLinkedProject) => dispatch(projectReducer.updateHasLinkedProject(id, hasLinkedProject)),

    updateLinkedScenarioId: (linkedScenarioId) => dispatch(projectReducer.updateLinkedScenarioId(id, linkedScenarioId)),

    updateLinkedProjectOutputMode: (mode) => dispatch(projectReducer.updateLinkedProjectOutputMode(id, mode)),

    updateLinkedSubgroup: (runId, sId, linkedRunId, percentage) => {
      dispatch(setupReducer.updateLinkedSubgroup(runId, sId, linkedRunId, percentage, id));
      dispatch(projectReducer.updateSetupFromLinked(id));
    },
    getIsContinuous: (id) => dispatch((dispatch, getState) => projectReducer.getIsContinuous(getState(), id)),

    updatePrimaryBusinessConstraintType: (runId, primaryConstraintType) =>
      dispatch(setupReducer.updatePrimaryBusinessConstraintType(id, runId, primaryConstraintType)),
    updateShowBalancerSettings: (showBalancerSettings) =>
      dispatch(chatGPTReducer.updateShowBalancerSettings(showBalancerSettings))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = getRunId(ownProps);

  const selectedRunId = projectReducer.getRunId(state, id);
  const innerRunId = projectReducer.getInnerId(state, id);
  let optimized = ownProps.optimized;
  if (!optimized || Number(optimized.projectId) !== Number(id)) {
    optimized = projectReducer.getOptimized(state, id);
  }

  let modelGroups = ownProps.modelGroups;
  if (!modelGroups || modelGroups.id !== id) {
    modelGroups = projectReducer.getModelGroups(state, id);
  }

  const runId =
    ownProps.isEditBlueprint && ownProps.editBlueprintId !== undefined
      ? ownProps.editBlueprintId
      : optimized && optimized.innerId !== undefined
        ? optimized.innerId
        : id;

  const setup =
    ownProps.isEditBlueprint && ownProps.editBlueprintId !== undefined
      ? setupReducer.getSetup(state, runId)
      : optimized && optimized.setup
        ? optimized.setup
        : setupReducer.getSetup(state, id);

  const selectedDataset = ownProps.selectedDataset
    ? ownProps.selectedDataset
    : setupReducer.getDatasetFromSetup(state, runId);
  const outcomeType = selectedDataset ? setupReducer.getOutcomeType(state, runId) : null;

  const linkedProjectId = projectReducer.getLinkedProjectId(state, id);
  const hasLinkedProject = projectReducer.getHasLinkedProject(state, id);

  const nextId = nextReducer.getNextIdFromProjectId(state, id);
  const linkedNextId = nextReducer.getNextIdFromProjectId(state, linkedProjectId);

  return {
    runId: runId,
    outcomeType: outcomeType,
    errorRuns: projectReducer.getErrorRuns(state, id),
    optimizer: projectReducer.getOptimizer(state, id),
    optimized: optimized,
    modelGroups: modelGroups,
    linkedModelGroups: projectReducer.getLinkedModelGroups(state, id),

    isContinuous: setupReducer.getIsContinuous(state, runId),

    segmentOptions: projectReducer.getSegmentOptions(state, id),

    project: projectReducer.getProject(state, id),

    groupInfo: projectReducer.getGroupInfo(state, id),

    optimalProfit: projectReducer.getOptimalProfit(state, id),
    optimalCost: projectReducer.getOptimalCost(state, id),

    model: projectReducer.getCapModel(state, id, selectedRunId),

    users: adminReducer.getUsers(state),

    runs: viewReducer.getRuns(state),

    continuousFrontier: projectReducer.getContinuousFrontier(state, id),

    aibleViewType: projectReducer.getAibleViewType(state, id),
    aibleViewTypeOptions: projectReducer.getAibleViewTypeOptions(state, id),

    isBusinessMode: globalReducer.getIsBusinessMode(state),
    isTableauMode: globalReducer.getIsTableauMode(state),

    isBusinessReality: runReducer.getIsBusinessReality(state, selectedRunId),
    isRealityHammer: setupReducer.getIsRealityHammer(state, runId),

    viewingScenarioIndex: projectReducer.getViewingScenarioIndex(state, id),
    compareScenarioIndex: projectReducer.getCompareScenarioIndex(state, id),

    selectedScenario: projectReducer.getSelectedScenario(state, id),

    allScenarios: projectReducer.getAllScenarios(state, id),

    scaledTotal: setupReducer.getScaledTotal(state, innerRunId),

    userName: loginReducer.getUserName(state),

    selectedDataset: setupReducer.getDatasetFromSetup(state, selectedRunId),
    terminalConditions: projectReducer.getTerminalConditions(state, id),
    activityConditions: projectReducer.getActivityConditions(state, id),
    uniqueId: projectReducer.getUniqueIdName(state, id),
    businessPredictionName: projectReducer.getBusinessPredictionName(state, id),

    showShortListed: projectReducer.getShowShortListed(state, id),
    showPending: projectReducer.getShowPending(state, id),

    projectMode: projectReducer.getProjectMode(state, id),

    sliderView: projectReducer.getSliderView(state, id),
    deployment: deployReducer.getProjectDeployment(state, id),

    monitorViewMode: monitoringReducer.getMonitorViewMode(state, id),

    retrainDataset: projectReducer.getRetrainDataset(state, id),

    isMonitorFeedback: projectReducer.getIsMonitorFeedback(state, id),
    isMonitorRetrain: projectReducer.getIsMonitorRetrain(state, id),
    isAFO: projectReducer.getIsAFO(state, id),
    isSharing: projectReducer.getIsSharing(state, id),
    isLoadingSharing: projectReducer.getIsLoadingSharing(state, id),

    canManageSegmentPermissions: projectReducer.getSegmentManagePermissions(state, id),
    canEditSegments: projectReducer.getSegmentEditPermissions(state, id),

    setup: setup,
    blueprint: setupReducer.getBlueprintFromSetup(state, id),

    currentSpend: projectReducer.getCurrentSpend(state, id, runId),
    currentProfit: projectReducer.getCurrentProfit(state, id, runId),
    currentRevenue: projectReducer.getCurrentRevenue(state, id, runId),

    customFields: blueprintReducer.getCustomFieldsTransformed(state, setup ? setup.blueprintId : undefined),
    customMappings: setupReducer.getCustomMappings(state, runId),

    isEditBlueprint: unifiedProjectReducer.getIsEditBlueprint(state, id),

    splitOptions: setupReducer.getSplitOptions(state, runId),

    projects: viewReducer.getProjects(state),
    linkProjectOptions: projectReducer.getLinkProjectOptions(state, id),

    hasLinkedProject: hasLinkedProject,

    linkedProject: projectReducer.getLinkedProject(state, id),
    linkedProjectId: linkedProjectId,
    linkedOptimized:
      hasLinkedProject && linkedProjectId !== undefined
        ? projectReducer.getOptimized(state, linkedProjectId)
        : undefined,
    linkedProjectOutputMode: projectReducer.getLinkedProjectOutputMode(state, id),
    linkedProjectOutputModeOption: projectReducer.getLinkedProjectOutputModeOption(state, id),
    linkedProjectOutputModeOptions: projectReducer.getLinkedProjectOutputModeOptions(state, id),

    balanceData: projectReducer.getBalanceData(state, id),
    balanceAlloc: projectReducer.getBalanceAlloc(state, id),
    isLoadingLink: projectReducer.getIsLoadingLink(state, id),
    isOptimizerWithinBounds: projectReducer.getOptimizerWithinBounds(state, id),
    primaryBusinessConstraintType: setupReducer.getPrimaryBusinessConstraintType(state, id, runId),

    next: nextReducer.getNext(state, nextId),
    linkedNext: nextReducer.getNext(state, linkedNextId),
    showBalancerSettings: chatGPTReducer.getShowBalancerSettings(state),

    isCheckBalance: chatGPTReducer.getIsCheckBalance(state),
    checkBalance: projectReducer.getCheckBalance(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(OptimizeContainer);
